import { type FC } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { NewsSentimentEnum } from "~/feature/chart/types";

import { labelByNewsSentiment, newsMarkerHint } from "./constants";
import * as Styled from "./NewsLegend.styles";

export const NewsLegend: FC = () => {
  const { settings } = useCoreChart();

  if (!settings.news) {
    return null;
  }

  return (
    <Styled.Root>
      <Styled.Caption>News</Styled.Caption>

      {Object.values(NewsSentimentEnum).map((sentiment) => (
        <Styled.Item key={sentiment}>
          <Styled.Dot $sentiment={sentiment} />
          <Styled.Label>{labelByNewsSentiment[sentiment]}</Styled.Label>
        </Styled.Item>
      ))}

      <Styled.Hint>{newsMarkerHint}</Styled.Hint>
    </Styled.Root>
  );
};
